import PropTypes from 'prop-types';
import React from 'react';

export const UpgradeUserMessage = ({ user }) => (<div>
    <p>
        There is already an account with that email.
        Would you like to upgrade this user?
    </p>
    <p>
        <strong>{user.firstName} {user.lastName}</strong>
        <br />
        {user.email}
    </p>
</div>);

UpgradeUserMessage.propTypes = {
    user: PropTypes.shape({
        email: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
    }),
};

export default UpgradeUserMessage;



// WEBPACK FOOTER //
// ./src/client/Components/PromptModal/UpgradeUserMessage.js